import { monoPalette } from "@/styles/themes/colors/palettes";

export const aliasLight = {
  main: monoPalette.light[100],
};
export type AliasLightScheme = "light";
export type AliasLight = `${AliasLightScheme}.${keyof typeof aliasLight}`;
